import { render } from "./TableRecord.vue?vue&type=template&id=2f66d374&scoped=true"
import script from "./TableRecord.vue?vue&type=script&lang=js"
export * from "./TableRecord.vue?vue&type=script&lang=js"

import "./TableRecord.vue?vue&type=style&index=0&id=2f66d374&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f66d374"]])

export default __exports__